import { render, staticRenderFns } from "./receiver.vue?vue&type=template&id=378dfb30&"
import script from "./receiver.vue?vue&type=script&lang=js&"
export * from "./receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports